<template>
  <div class="login">
    <img class="banner" src="../../assets/images/login/masterImg.png"/>
    <img class="topImg" src="../../assets/images/login/bottomImg.png"/>
    <img class="bottomImg" src="../../assets/images/login/bottomImg.png"/>
    <div class="loginContent">
      <div class="content">
        <div class="topLogo"><img src="../../assets/images/login/logo.png">固德商城后台系统</div>
        <div class="form">
          <el-form :model="formValue" :rules="rules" ref="form" class="form">
            <el-form-item prop="userName" class="userName">
              <img src="../../assets/images/login/user.png" /><el-input v-model="formValue.userName" auto-complete="off" placeholder="用户"></el-input>
            </el-form-item>
            <el-form-item prop="password" class="password">
              <img src="../../assets/images/login/lock.jpg"  /> <el-input type="password" v-model="formValue.password" auto-complete="off" placeholder="密码"></el-input>
            </el-form-item>
            <el-form-item v-if="errorCount > 3" prop="code" class="code">
              <el-input v-model="formValue.code" placeholder="验证码"></el-input><img :src="codeImage" @click="generareCode" class="codeImage"/>
            </el-form-item>
            <el-form-item class="remember">
              <el-checkbox v-model="rememberPwd" class="rememberPwd">记住密码</el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button @click="submit()" native-type="submit" class="submitBtn" :loading="loading">登入</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LoginService } from '../../service/login.service';
import { Storage } from '../../service/core/storage';
import CheckCodeImage from '../../utils/checkCodeImage';
  export default {
    name: 'login',
    data() {
       const validatePass = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入密码'));
        } else {
          callback();
        }
      };
      const validateUserName = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入用户名'));
        } else {
          callback();
        }
      };
      const validateCode = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入验证码'));
        } else if(value.toLocaleLowerCase() !== this.verifyCode) {
          callback(new Error('验证码错误'));
        } else {
          callback();
        }
      };
      validateCode
      return {
        loading: false,
        rememberPwd: false,
        errorCount: 0,
        formValue: {
          userName: '',
          password: '',
          code: '',
        },
        codeImage: '',
        verifyCode: '',
        rules: {
          password: [
            { validator: validatePass, trigger: 'change' }
          ],
          userName: [
            { validator: validateUserName, trigger: 'change' }
          ],
          code: [
            { validator: validateCode, trigger: 'blur' }
          ]
        }
      }
    },
    created() {
      this.formValue.password = Storage.get('pwd');
      this.formValue.userName = Storage.get('userName');
      this.rememberPwd = JSON.parse(Storage.get('rememberPwd'));
      this.generareCode();
    },
    methods: {
      generareCode() {
        const checkCode = new CheckCodeImage();
        const { dataURL, code } = checkCode.create();
        this.codeImage = dataURL;
        this.verifyCode = code;
      },
      submit() {
        this.$refs.form.validate(async (valid) => {
          if (!valid) { return ; }
          this.loading = true;
          try {
            await LoginService.login(this.formValue.userName, this.formValue.password).then(res=>{
              let user = JSON.stringify({name:this.formValue.userName,id:res.id})
              localStorage.setItem("user",user);  
              this.setAfterLoginData();
              this.$router.push('/index');
            });
          } catch(e) {
            this.generareCode();
            this.errorCount++;
          } finally {
            this.loading = false;
          }
        });
      },
      setAfterLoginData() {
        Storage.set('rememberPwd', this.rememberPwd);
        if (this.rememberPwd) {
          Storage.set('pwd', this.formValue.password);
          Storage.set('userName', this.formValue.userName);
        } else {
          Storage.remove('pwd');
          Storage.remove('userName');
        }
        
      }
    }
  }
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 1vw;
  .banner {
    width: 36vw;
    height: 31vw;
    margin-bottom: 60px;
    margin-left: 150px;
    position: absolute;
    top: 120px;
    left: 0;
    z-index: 4;
  }
  .bottomImg {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 200px;
    width: 48%;
  }
  .topImg {
    position: absolute;
    top: 0;
    right: 0;
    transform: rotate(180deg);
    height: 200px;
    width: 48%;
  }
  .loginContent {
    margin-top: 60px;
    // height: 31vw;
    width: 28vw;
    background-color: #fff;
    box-shadow: 0px 9px 15px 1px
      rgba(52, 122, 250, 0.12);
    border-radius: 10px;
    margin-right: 220px;
    display: flex;
    position: relative;
    z-index: 5;
    flex-direction: column;
    .topLogo {
      background: #116ace;
      height: 3vw;
      margin: 0 4.5vw;
      margin-top: -25px;
      border-radius: 50px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.2vw;
      letter-spacing: 2px;
      img {
        height: 30px;
        width: 30px;
        margin-right: 10px;
      }
    }
    .form {
      margin: 1vw 35px;
      margin-top: 3.8vw;
      .userName, .password, .code {
        margin-bottom: 2vw;
        img {
          height: 2vw;
          min-width: 1.7vw;
        }
        .codeImage {
          min-width: 9vw;
          height: 2.8vw;
        }
        & /deep/ {
          .el-form-item__content {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #d2d2d2;
            .el-input {
              input {
                font-size: 1.2vw;
                border: none;
              }
            }
          }
        }
      }
      .remember {
        width: 20px;
        .rememberPwd {
          color: #aaa;
        }
      }
      .submitBtn {
        height: 2.5vw;
        width: 17vw;
        background-color: #116ace;
        border-radius: 20px;
        margin-bottom: 3vw;
        color: #fff;
        border: none;
      }
    }
  }
}

</style>